import { SizingData } from './getSizingData';
import forceHiddenStyles from './forceHiddenStyles';
let hiddenTextarea = null;
const getHeight = (node, sizingData) => {
  const height = node.scrollHeight;
  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: добавить границу, начиная с высоты = content + padding + border
    return height + sizingData.borderSize;
  }

  // удалить padding, так как height = content
  return height - sizingData.paddingSize;
};
export default function calculateNodeHeight(sizingData, value, minRows = 1, maxRows = Infinity) {
  if (typeof window !== 'undefined') {
    if (!hiddenTextarea) {
      hiddenTextarea = document.createElement('textarea');
      hiddenTextarea.setAttribute('tabindex', '-1');
      hiddenTextarea.setAttribute('aria-hidden', 'true');
      forceHiddenStyles(hiddenTextarea);
    }
    if (hiddenTextarea.parentNode === null) {
      document.body.appendChild(hiddenTextarea);
    }
  }
  if (hiddenTextarea === null) {
    return [0, 0];
  }
  const {
    paddingSize,
    borderSize,
    sizingStyle
  } = sizingData;
  const {
    boxSizing
  } = sizingStyle;
  Object.keys(sizingStyle).forEach(_key => {
    const key = _key;
    if (hiddenTextarea) {
      hiddenTextarea.style[key] = sizingStyle[key];
    }
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  let height = getHeight(hiddenTextarea, sizingData);

  // измерить высоту текстового поля с одной строкой
  hiddenTextarea.value = 'x';
  const rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  let minHeight = rowHeight * minRows;
  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }
  height = Math.max(minHeight, height);
  let maxHeight = rowHeight * maxRows;
  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }
  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}